import { render } from "./EventsGridPage.vue?vue&type=template&id=1b3e0019&ts=true"
import script from "./EventsGridPage.vue?vue&type=script&lang=ts"
export * from "./EventsGridPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__